module.exports = __webpack_public_path__ + "img/assurance-lazy.8b7263c4.jpg";